import { colors as o } from "./tokens/index.js";
import r from "./tokens/fonts.js";
import m from "./tokens/fontSizes.js";
import i from "./tokens/fontWeights.js";
import t from "./tokens/radii.js";
import f from "./tokens/lineHeights.js";
import p from "./tokens/spacings.js";
import s from "./tokens/shadows.js";
import e from "./tokens/icons.js";
const z = {
  colors: o,
  fonts: r,
  fontSizes: m,
  fontWeights: i,
  radii: t,
  lineHeights: f,
  spacings: p,
  shadows: s,
  icons: e
};
export {
  z as theme
};
